import { Box, Chip, styled, useTheme } from '@mui/material';
import { CheckmarkIcon, CloseIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { PoolTooltip } from '@synergy/components-next';
import { ReactElement } from 'react';

import { SupplierClassification } from '../../../../models/enums/supplier-classification';
import { SupplierListItemBoxProps } from './supplier-list-item-box-props';

const ChipContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1.5),
    rowGap: theme.spacing(0.5),
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
}));

const Badge = (props: { isActive?: boolean } & React.ComponentProps<typeof Chip>): ReactElement => {
    const theme = useTheme();

    const Icon = props.isActive ? CheckmarkIcon : CloseIcon;

    return (
        <Chip
            icon={<Icon sx={{ fontSize: theme => theme.spacing(2), strokeWidth: 2 }} />}
            color={props.isActive ? 'successDark' : 'default'}
            sx={{
                ...(props.isActive ? {} : { textDecoration: 'line-through' }),
                ...theme.typography.statusLabel,
                lineHeight: 'unset',
            }}
            size="smaller"
            disabled={!props.isActive}
            {...props}
        />
    );
};

export const SupplierListBoxBadges = (props: SupplierListItemBoxProps): ReactElement => {
    const isContractPartner = props.item.classification === SupplierClassification.Contract;

    return (
        <ChipContainer>
            <PoolTooltip
                mobileClickToOpen={true}
                preventPropagation={true}
                title={<FormattedMessage id="app.supplierDirectory.card.orderByPool.tooltip" />}
            >
                <Badge isActive={true} label={<FormattedMessage id="app.supplierDirectory.card.orderByPool" />} />
            </PoolTooltip>
            <PoolTooltip
                mobileClickToOpen={true}
                preventPropagation={true}
                title={
                    <FormattedMessage
                        id={
                            isContractPartner
                                ? 'app.supplierDirectory.card.orderBySupplier.tooltip'
                                : 'app.supplierDirectory.card.orderBySupplier.tooltip.disabled'
                        }
                    />
                }
            >
                <Badge
                    isActive={isContractPartner}
                    label={<FormattedMessage id="app.supplierDirectory.card.orderBySupplier" />}
                />
            </PoolTooltip>
        </ChipContainer>
    );
};
